import { create } from 'zustand'

interface AffiliateWelcomeStore {
  isOpen: boolean
  openWelcome: () => void
  closeWelcome: () => void
}

/**
 * Whether the "you are in, here is what to do first" modal is showing.
 *
 * It lives outside the two doors into the program (the sidebar's activation
 * dialog and the section's own landing) because both of them join through the
 * same mutation, and the modal has to greet the new affiliate either way. Not
 * persisted on purpose: it is an acknowledgement of something that just
 * happened, so a reload must not replay it.
 */
export const useAffiliateWelcomeStore = create<AffiliateWelcomeStore>(
  (set) => ({
    isOpen: false,
    openWelcome: () => set({ isOpen: true }),
    closeWelcome: () => set({ isOpen: false }),
  }),
)
